<!-- ============================================================
     ATTENDANCE MANAGEMENT
     Tabs: Mark · Records · Reports · Leaves
     ============================================================ -->
<div class="att-page">

  @if (saveSuccess()) {
  <div class="att-toast alert alert-success d-flex align-items-center gap-2 shadow">
    <i class="bi bi-check-circle-fill fs-5"></i><strong>{{ saveSuccess() }}</strong>
  </div>
  }

  <!-- ══ NOTICE MODAL ════════════════════════════════════════ -->
  @if (showNoticeModal() && noticingStudent()) {
  @let ns = noticingStudent()!;
  <div class="att-overlay" (click)="showNoticeModal.set(false)">
    <div class="att-modal notice-modal" (click)="$event.stopPropagation()">
      <div class="amh" style="background:linear-gradient(135deg,#dc2626,#b91c1c)">
        <div class="amh-icon"><i class="bi bi-envelope-exclamation-fill"></i></div>
        <div>
          <h5 class="amh-title">Send Attendance Notice</h5>
          <p class="amh-sub">{{ ns.student_name }} · {{ ns.class_name }} · Roll: {{ ns.roll_no }}</p>
        </div>
        <button class="amh-close" (click)="showNoticeModal.set(false)"><i class="bi bi-x-lg"></i></button>
      </div>
      <div class="amb p-4">
        <!-- Student summary bar -->
        <div class="notice-student-bar mb-4">
          <div class="nsb-av" [style.background]="pctColor(ns.percentage)">{{ ns.student_name.charAt(0) }}</div>
          <div class="nsb-info">
            <div class="fw-bold">{{ ns.student_name }}</div>
            <div class="small text-muted">{{ ns.class_name }} · Roll: {{ ns.roll_no }}</div>
          </div>
          <div class="nsb-pct" [style.color]="pctColor(ns.percentage)">
            <div class="nsb-pct-val">{{ ns.percentage }}%</div>
            <div class="nsb-pct-lbl">Attendance</div>
          </div>
          <div class="nsb-stats">
            <div class="nsb-stat"><span class="fw-bold text-success">{{ ns.present }}</span>
              <div class="tiny text-muted">Present</div>
            </div>
            <div class="nsb-stat"><span class="fw-bold text-danger">{{ ns.absent }}</span>
              <div class="tiny text-muted">Absent</div>
            </div>
            <div class="nsb-stat"><span class="fw-bold text-warning">{{ ns.late }}</span>
              <div class="tiny text-muted">Late</div>
            </div>
          </div>
        </div>
        <!-- Editable message -->
        <div class="d-flex align-items-center justify-content-between mb-2">
          <label class="form-label fw-semibold mb-0">Notice Message <span class="text-muted small fw-normal">(editable
              before sending)</span></label>
          <span class="badge bg-danger-subtle text-danger small">Below 75% Attendance</span>
        </div>
        <textarea class="form-control notice-textarea" [(ngModel)]="noticeMessage" rows="12"></textarea>
        <!-- <div class="notice-send-info mt-2 small text-muted">
            <i class="bi bi-info-circle me-1"></i>
            This notice will be recorded in the system and marked as sent. You may send via SMS / Email / Print as appropriate.
          </div> -->
      </div>
      <div class="amf">
        <button class="btn btn-outline-secondary px-4" (click)="showNoticeModal.set(false)">Cancel</button>
        <button class="btn btn-danger px-5" (click)="sendNotice()">
          <i class="bi bi-send-fill me-2"></i>Send Notice to Parent
        </button>
      </div>
    </div>
  </div>
  }

  <!-- ══ REJECT REASON MODAL ════════════════════════════════ -->
  @if (showRejectModal() !== null) {
  <div class="att-overlay" (click)="showRejectModal.set(null)">
    <div class="att-modal reject-modal" (click)="$event.stopPropagation()">
      <div class="amh" style="background:linear-gradient(135deg,#dc2626,#ef4444)">
        <div class="amh-icon"><i class="bi bi-x-circle-fill"></i></div>
        <div>
          <h5 class="amh-title">Reject Leave Application</h5>
          <p class="amh-sub">A reason must be provided</p>
        </div>
        <button class="amh-close" (click)="showRejectModal.set(null)"><i class="bi bi-x-lg"></i></button>
      </div>
      <div class="amb p-4">
        <label class="form-label fw-semibold">Rejection Reason <span class="req">*</span></label>
        <textarea class="form-control" [(ngModel)]="rejectRemark" rows="4" maxlength="300"
          placeholder="State clearly why this leave is being rejected…"></textarea>
        @if (!rejectRemark.trim()) {
        <div class="text-danger small mt-1"><i class="bi bi-exclamation-circle me-1"></i>Rejection reason is required.
        </div>
        }
      </div>
      <div class="amf">
        <button class="btn btn-outline-secondary px-4" (click)="showRejectModal.set(null)">Cancel</button>
        <button class="btn btn-danger px-5" (click)="confirmQuickReject()" [disabled]="!rejectRemark.trim()">
          <i class="bi bi-x-circle-fill me-2"></i>Confirm Reject
        </button>
      </div>
    </div>
  </div>
  }

  <!-- ══ EDIT LEAVE MODAL ════════════════════════════════════ -->
  @if (showEditLeaveModal()) {
  <div class="att-overlay" (click)="showEditLeaveModal.set(false)">
    <div class="att-modal edit-leave-modal" (click)="$event.stopPropagation()">
      <div class="amh" style="background:linear-gradient(135deg,#d97706,#f59e0b)">
        <div class="amh-icon"><i class="bi bi-pencil-fill"></i></div>
        <div>
          <h5 class="amh-title">Edit Leave Application</h5>
          <p class="amh-sub">{{ editLeaveForm.student_name }} · {{ editLeaveForm.class_name }}</p>
        </div>
        <button class="amh-close" (click)="showEditLeaveModal.set(false)"><i class="bi bi-x-lg"></i></button>
      </div>
      <div class="amb p-4">
        <!-- Read-only info strip -->
        <div class="edit-leave-info mb-3">
          <div class="eli-badge"><i class="bi bi-person-fill me-1 text-muted"></i><span>{{ editLeaveForm.student_id
              }}</span></div>
          <div class="eli-badge"><i class="bi bi-123 me-1 text-muted"></i><span>Roll: {{ editLeaveForm.roll_no }}</span>
          </div>
          <div class="eli-badge"><i class="bi bi-calendar-check me-1 text-muted"></i><span>Applied: {{
              formatDate(editLeaveForm.applied_on ?? '') }}</span></div>
          <div class="eli-badge"><i class="bi bi-flag me-1 text-muted"></i>
            <span class="leave-status-badge {{ getLeaveStatusClass($any(editLeaveForm.status ?? 'Pending')) }}">
              {{ editLeaveForm.status }}
            </span>
          </div>
        </div>
        <div class="row g-3">
          <!-- Student name -->
          <div class="col-12">
            <label class="form-label fw-semibold">Student Name <span class="req">*</span></label>
            <input type="text" class="form-control" [(ngModel)]="editLeaveForm.student_name" maxlength="100"
              [class.is-invalid]="editLeaveSubmitted && !editLeaveForm.student_name?.trim()">
            @if (editLeaveSubmitted && !editLeaveForm.student_name?.trim()) {
            <div class="invalid-feedback">Student name is required.</div>
            }
          </div>
          <!-- Class & Leave Type -->
          <div class="col-md-6">
            <label class="form-label fw-semibold">Class</label>
            <select class="form-select" [(ngModel)]="editLeaveForm.class_name">
              @for (c of classOptions; track c) { <option [value]="c">{{ c }}</option> }
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label fw-semibold">Leave Type</label>
            <select class="form-select" [(ngModel)]="editLeaveForm.leave_type">
              @for (t of leaveTypes; track t) { <option [value]="t">{{ t }}</option> }
            </select>
          </div>
          <!-- Dates -->
          <div class="col-6">
            <label class="form-label fw-semibold">From Date <span class="req">*</span></label>
            <input type="date" class="form-control" [(ngModel)]="editLeaveForm.from_date"
              [class.is-invalid]="editLeaveSubmitted && !editLeaveForm.from_date">
          </div>
          <div class="col-6">
            <label class="form-label fw-semibold">To Date <span class="req">*</span></label>
            <input type="date" class="form-control" [(ngModel)]="editLeaveForm.to_date"
              [class.is-invalid]="editLeaveSubmitted && !editLeaveForm.to_date">
          </div>
          <!-- Reason -->
          <div class="col-12">
            <label class="form-label fw-semibold">Reason <span class="req">*</span></label>
            <textarea class="form-control" [(ngModel)]="editLeaveForm.reason" rows="3" maxlength="300"
              [class.is-invalid]="editLeaveSubmitted && !editLeaveForm.reason?.trim()"></textarea>
            @if (editLeaveSubmitted && !editLeaveForm.reason?.trim()) {
            <div class="invalid-feedback">Reason is required.</div>
            }
          </div>
          <!-- Admin remark -->
          <div class="col-12">
            <label class="form-label fw-semibold text-muted small">Admin Remark <span
                class="text-muted fw-normal">(internal note, optional)</span></label>
            <input type="text" class="form-control" [(ngModel)]="editLeaveForm.review_remark" maxlength="200"
              placeholder="e.g. Verified with class teacher">
          </div>
        </div>
      </div>
      <div class="amf">
        <button class="btn btn-outline-secondary px-4" (click)="showEditLeaveModal.set(false)">Cancel</button>
        <button class="btn att-btn-primary px-5" (click)="saveEditLeave()">
          <i class="bi bi-save-fill me-2"></i>Save Changes
        </button>
      </div>
    </div>
  </div>
  }

  <!-- ══ LEAVE DETAIL MODAL ══════════════════════════════════ -->
  @if (showLeaveModal() && viewingLeave()) {
  @let lv = viewingLeave()!;
  <div class="att-overlay" (click)="showLeaveModal.set(false)">
    <div class="att-modal" (click)="$event.stopPropagation()">
      <div class="amh {{ getLeaveStatusClass(lv.status) }}">
        <div class="amh-icon"><i class="bi bi-calendar-event-fill"></i></div>
        <div>
          <h5 class="amh-title">Leave Application</h5>
          <p class="amh-sub">{{ lv.student_name }} · {{ lv.class_name }} · Roll: {{ lv.roll_no }}</p>
        </div>
        <button class="amh-close" (click)="showLeaveModal.set(false)"><i class="bi bi-x-lg"></i></button>
      </div>
      <div class="amb p-4">
        <div class="leave-detail-grid">
          <div class="ldg-item"><span class="ldg-label">Leave Type</span><span class="ldg-val">{{ lv.leave_type
              }}</span></div>
          <div class="ldg-item"><span class="ldg-label">From</span><span class="ldg-val">{{ formatDate(lv.from_date)
              }}</span></div>
          <div class="ldg-item"><span class="ldg-label">To</span><span class="ldg-val">{{ formatDate(lv.to_date)
              }}</span></div>
          <div class="ldg-item"><span class="ldg-label">Total Days</span><span class="ldg-val fw-bold text-primary">{{
              lv.total_days }} day(s)</span></div>
          <div class="ldg-item col-span-2"><span class="ldg-label">Reason</span><span class="ldg-val">{{ lv.reason
              }}</span></div>
          <div class="ldg-item"><span class="ldg-label">Applied On</span><span class="ldg-val">{{
              formatDate(lv.applied_on) }}</span></div>
          <div class="ldg-item"><span class="ldg-label">Status</span><span
              class="leave-status-badge {{ getLeaveStatusClass(lv.status) }}">{{ lv.status }}</span></div>
          @if (lv.reviewed_by) {
          <div class="ldg-item"><span class="ldg-label">Reviewed by</span><span class="ldg-val">{{ lv.reviewed_by
              }}</span></div>
          <div class="ldg-item col-span-2"><span class="ldg-label">Review Remark</span><span
              class="ldg-val text-muted">{{ lv.review_remark }}</span></div>
          }
        </div>
        @if (lv.status === 'Pending') {
        <div class="mt-4">
          <label class="form-label fw-semibold">Review Remark</label>
          <input type="text" class="form-control mb-3" [(ngModel)]="lv.review_remark"
            placeholder="Optional note to student/parent…">
          <div class="d-flex gap-3">
            <button class="btn btn-success flex-fill" (click)="approveLeave(lv)">
              <i class="bi bi-check-circle-fill me-2"></i>Approve
            </button>
            <button class="btn btn-danger flex-fill" (click)="rejectLeave(lv)">
              <i class="bi bi-x-circle-fill me-2"></i>Reject
            </button>
          </div>
        </div>
        }
      </div>
      <div class="amf">
        <button class="btn btn-outline-secondary px-4" (click)="showLeaveModal.set(false)">Close</button>
      </div>
    </div>
  </div>
  }

  <!-- ===================== PAGE HEADER ===================== -->
  <div class="att-ph mb-4">
    <div>
      <h1 class="att-title"><i class="bi bi-calendar-check-fill me-2 text-primary" style="font-size:1.1rem;">
        </i>Attendance Management
      </h1>
      <p class="att-subtitle">Mark · Track · Report · Manage Leave · Send Notices</p>
    </div>
    <div class="d-flex flex-column align-items-end">
      <!-- ===================== TABS ===================== -->
      <div class="att-tabs">
        @for (tab of [{k:'mark',l:'Mark
        Attendance',ic:'bi-pencil-fill'},{k:'records',l:'Records',ic:'bi-table'},{k:'reports',l:'Reports',ic:'bi-bar-chart-fill'},{k:'leaves',l:'Leaves',ic:'bi-calendar-event-fill'}];
        track tab.k) {
        <button class="atab" [class.active]="activeTab() === tab.k" (click)="activeTab.set($any(tab.k))">
          <i class="bi {{ tab.ic }} me-1"></i>{{ tab.l }}
          @if (tab.k === 'leaves' && leaveSummary().pending > 0) {
          <span class="pending-badge">{{ leaveSummary().pending }}</span>
          }
          @if (tab.k === 'reports' && lowAttendanceStudents().length > 0) {
          <span class="pending-badge" style="background:#f59e0b;">{{ lowAttendanceStudents().length }}</span>
          }
        </button>
        }
      </div>
    </div>
    <!-- @if (activeTab() === 'leaves') {
    <button class="btn att-btn-primary btn-sm" (click)="showAddLeave.set(true); newLeave={}; leaveSubmitted=false">
      <i class="bi bi-plus-circle-fill me-1"></i>Add Leave Application
    </button>
    }
    @if (activeTab() === 'reports' && lowAttendanceStudents().length > 0) {
    <button class="btn btn-danger btn-sm" (click)="sendAllNotices()">
      <i class="bi bi-envelope-fill me-1"></i>
      Send All Notices
      @if (noticeCount() > 0) { <span class="ms-1">({{ noticeCount() }} sent)</span> }
    </button>
    } -->
  </div>

  <!-- ===================================================
       TAB 1: MARK ATTENDANCE
       =================================================== -->
  @if (activeTab() === 'mark') {
  <div class="row g-4">

    <!-- Left: Settings Panel -->
    <div class="col-xl-3 col-lg-4">
      <div class="att-card sticky-top" style="top:80px;">
        <div class="ac-header"><i class="bi bi-sliders me-2"></i>Session Setup</div>
        <div class="ac-body">
          <div class="row g-3">
            <div class="col-12">
              <label class="form-label fw-semibold">Date</label>
              <input type="date" class="form-control" [(ngModel)]="markDate" (change)="loadStudents(true)">
            </div>
            <div class="col-12">
              <label class="form-label fw-semibold">Class</label>
              <select class="form-select" [(ngModel)]="markClass" (change)="loadStudents(true)">
                <option value="">--</option>
                @for (c of classOptions; track c) { <option [value]="c.code">{{ c.name }}</option> }
              </select>
            </div>
            <div class="col-6">
              <label class="form-label fw-semibold">Section</label>
              <select class="form-select" [(ngModel)]="markSection" (change)="loadStudents(true)">
                <option value="">--</option>
                @for (s of sectionOpts; track s) { <option [value]="s.code">{{ s.name }}</option> }
              </select>
            </div>
            <div class="col-6">
              <label class="form-label fw-semibold">Period</label>
              <select class="form-select" [(ngModel)]="markPeriod" (change)="loadStudents(true)">
                <option value="">--</option>
                @for (p of periodOpts; track p) { <option [value]="p">{{ p }}</option> }
              </select>
            </div>
            <div class="col-12">
              <label class="form-label fw-semibold">Subject</label>
              <select class="form-select" [(ngModel)]="markSubject" (change)="loadStudents(true)">
                <option value="">--</option>
                @for (s of subjectOpts; track s) { <option [value]="s.code">{{ s.name }}</option> }
              </select>
            </div>
            <div class="col-12">
              <div class="holiday-toggle" [class.holiday-on]="isHoliday">
                <label class="ht-label" for="holidayChk"><i class="bi bi-sun-fill me-2"></i>Mark as Holiday</label>
                <div class="form-check form-switch mb-0">
                  <input class="form-check-input" type="checkbox" id="holidayChk" [(ngModel)]="isHoliday">
                </div>
              </div>
              @if (isHoliday) {
              <input type="text" class="form-control mt-2" [(ngModel)]="holidayName"
                placeholder="Holiday name (e.g. Diwali)">
              }
            </div>
          </div>

          @if (!isHoliday) {
          <div class="att-summary-box mt-4">
            <div class="asb-row">
              <div class="asb-dot present"></div><span>Present</span><span class="ms-auto fw-bold text-success">{{
                markSummary().present }}</span>
            </div>
            <div class="asb-row">
              <div class="asb-dot absent"></div><span>Absent</span><span class="ms-auto fw-bold text-danger">{{
                markSummary().absent }}</span>
            </div>
            <div class="asb-row">
              <div class="asb-dot late"></div><span>Late</span><span class="ms-auto fw-bold text-warning">{{
                markSummary().late }}</span>
            </div>
            <div class="asb-row">
              <div class="asb-dot halfday"></div><span>Half-Day</span><span class="ms-auto fw-bold text-info">{{
                markSummary().half_day }}</span>
            </div>
            <div class="asb-row">
              <div class="asb-dot leave"></div><span>On Leave</span><span class="ms-auto fw-bold text-purple">{{
                markSummary().on_leave }}</span>
            </div>
            <div class="asb-total"><span>Total Students</span><span>{{ markSummary().total }}</span></div>
          </div>
          }

          <!-- @if (!isHoliday && attendanceRows().length > 0) {
          <div class="bulk-actions mt-3">
            <p class="small text-muted mb-2 fw-semibold">Bulk Mark:</p>
            <div class="d-flex flex-wrap gap-2">
              @for (st of ['Present','Absent','Late','Half-Day','Leave']; track st) {
              <button class="bulk-btn att-{{ st.toLowerCase().replace(' ','-').replace('half-day','halfday') }}"
                (click)="setAllStatus($any(st))">All {{ st }}</button>
              }
            </div>
          </div>
          } -->

          <button class="btn att-btn-primary w-100 mt-4 py-2" (click)="saveAttendance()"
            [disabled]="(!isHoliday && attendanceRows().length === 0) || sessionSaved">
            @if (sessionSaved) { <i class="bi bi-check-circle-fill me-2"></i>Saved! }
            @else { <i class="bi bi-save-fill me-2"></i>Save Attendance }
          </button>
        </div>
      </div>
    </div>

    <!-- Right: Student List -->
    <div class="col-xl-9 col-lg-8">
      @if (isHoliday) {
      <div class="holiday-banner">
        <i class="bi bi-sun-fill"></i>
        <div>
          <h5>{{ holidayName || 'Holiday' }}</h5>
          <p>{{ formatDate(markDate) }} · No attendance required</p>
        </div>
      </div>
      } @else if (attendanceRows().length === 0) {
      <div class="empty-state"><i class="bi bi-people"></i>
        <p>No students found for this class</p>
      </div>
      } @else {
      <!-- Search bar for student grid -->
      <div class="mark-search-bar mb-3">
        <div class="input-group mark-search-input">
          <span class="input-group-text bg-light border-end-0"><i class="bi bi-search text-muted"></i></span>
          <input class="form-control border-start-0" placeholder="Search student by name or roll no…"
            [value]="markSearch()" (input)="markSearch.set($any($event.target).value)">
          @if (markSearch()) {
          <button class="btn btn-outline-secondary" (click)="markSearch.set('')"><i class="bi bi-x"></i></button>
          }
        </div>
        @if (markSearch()) {
        <small class="text-muted">Showing {{ filteredAttendanceRows().length }} of {{ attendanceRows().length }}
          students</small>
        }
      </div>

      <!-- Status legend -->
      <!-- <div class="status-legend mb-3">
        @for (st of
        [{l:'Present',c:'att-present',ic:'bi-check-circle-fill'},{l:'Absent',c:'att-absent',ic:'bi-x-circle-fill'},{l:'Late',c:'att-late',ic:'bi-clock-fill'},{l:'Half-Day',c:'att-halfday',ic:'bi-circle-half'},{l:'On
        Leave',c:'att-leave',ic:'bi-calendar-event-fill'}]; track st.l) {
        <span class="sl-item {{ st.c }}"><i class="bi {{ st.ic }} me-1"></i>{{ st.l }}</span>
        }
      </div> -->
      <div class="bulk-actions mt-3 mb-2">
        <div class="d-flex gap-2 align-items-center">
          <span class="text-muted fw-semibold">Bulk Mark:</span>
          @for (st of ['Present','Absent','Late','Half-Day','Leave']; track st) {
          <button class="bulk-btn att-{{ st.toLowerCase().replace(' ','-').replace('half-day','halfday') }}"
            (click)="setAllStatus($any(st))">All {{ st }}</button>
          }
        </div>
      </div>

      @if (filteredAttendanceRows().length === 0) {
      <div class="empty-state"><i class="bi bi-search"></i>
        <p>No students match "{{ markSearch() }}"</p>
      </div>
      } @else {
      <div class="students-grid">
        @for (row of filteredAttendanceRows(); track row.id) {
        <div class="flip-box student-card 
          {{ row.status === 'Absent' ? 'sc-absent' : row.status === 'Late' ? 'sc-late' : 
          row.status === 'Present' ? 'sc-present' : row.status === 'Half-Day' ? 'sc-hday' : 
          row.status === 'Leave' ? 'sc-leave' : '' }}
        ">
          <div class="flip-box-inner">
            <div class="sc-top flip-box-front">
              <div class="sc-avatar" 
                [class.absent-av]="row.status === 'Absent'"
                [class.late-av]="row.status === 'Late'"
                [class.present-av]="row.status === 'Present'"
                [class.hday-av]="row.status === 'Half-Day'"
                [class.leave-av]="row.status === 'Leave'"
              >
                @if(row.profile_photo) {
                  <img [src]="row.profile_photo" style="width: 100%; height: 100%; border-radius: 6px;">
                } @else {
                  {{ row.name.charAt(0) }}
                }
              </div>
              <div class="sc-info">
                <div class="sc-name">{{ row.name }}</div>
                <div class="sc-roll">{{ row.roll_no }} · {{ row.gender }}</div>
              </div>
              <div class="sc-status-icon">
                <i
                  class="bi {{ getStatusIcon(row.status) }} {{ row.status === 'Present' ? 'text-success' : row.status === 'Absent' ? 'text-danger' : row.status === 'Late' ? 'text-warning' : row.status === 'Half-Day' ? 'text-info' : 'text-purple' }}"></i>
              </div>
            </div>

            <div class="flip-box-back">
              <div class="sc-btns">
                @for (st of ['Present','Absent','Late','Half-Day','Leave']; track st) {
                <button class="scb {{ row.status === st ? 'scb-active scb-' + st.toLowerCase().replace(' ','-') : '' }}"
                  (click)="setStatus(row.id, $any(st))">
                  {{ st === 'Half-Day' ? 'H/D' : st === 'Leave' ? 'Leave' : st.slice(0,1) + st.slice(1,3) }}
                </button>
                }
              </div>
              <input type="text" class="form-control form-control-sm remark-input" [(ngModel)]="row.remark"
                [name]="'rem_'+row.id" placeholder="Remark (optional)">
            </div>
          </div>
        </div>
        }
      </div>
      }
      }
    </div>

  </div>
  }

  <!-- ===================================================
       TAB 2: RECORDS
       =================================================== -->
  @if (activeTab() === 'records') {
  <div class="att-card mb-3">
    <div class="ac-body">
      <div class="row g-3 align-items-end">
        <!-- Search -->
        <!-- <div class="col-md-4">
          <label class="form-label small fw-semibold text-muted">Search</label>
          <div class="input-group">
            <span class="input-group-text bg-light border-end-0"><i class="bi bi-search text-muted"></i></span>
            <input class="form-control border-start-0" placeholder="Class, subject, teacher…" [value]="recSearch()"
              (input)="recSearch.set($any($event.target).value)">
            @if (recSearch()) { <button class="btn btn-outline-secondary" (click)="recSearch.set('')"><i
                class="bi bi-x"></i></button> }
          </div>
        </div> -->
        <!-- Class -->
        <div class="col-md-2">
          <label class="form-label small fw-semibold text-muted">Class</label>
          <select class="form-select" [value]="recClass()" (change)="recClass.set($any($event.target).value)">
            <option value="">All Classes</option>
            @for (c of classOptions; track c) { <option [value]="c.code">{{ c.name }}</option> }
          </select>
        </div>
        <!-- Section -->
        <div class="col-md-1">
          <label class="form-label small fw-semibold text-muted">Sec.</label>
          <select class="form-select" [value]="recSection()" (change)="recSection.set($any($event.target).value)">
            <option value="">All</option>
            @for (s of sectionOpts; track s) { <option [value]="s.code">{{ s.name }}</option> }
          </select>
        </div>
        <!-- Subject -->
        <div class="col-md-2">
          <label class="form-label small fw-semibold text-muted">Subject</label>
          <select class="form-select" [value]="recSubject()" (change)="recSubject.set($any($event.target).value)">
            <option value="">All Subjects</option>
            @for (s of subjectOpts; track s) { <option [value]="s.code">{{ s.name }}</option> }
            <option value="All Subjects">All Subjects</option>
          </select>
        </div>
        <!-- Type: School Day / Holiday -->
        <!-- <div class="col-md-2">
          <label class="form-label small fw-semibold text-muted">Day Type</label>
          <select class="form-select" [value]="recStatus()" (change)="recStatus.set($any($event.target).value)">
            <option value="">All Days</option>
            <option value="normal">School Days</option>
            <option value="holiday">Holidays Only</option>
          </select>
        </div> -->
      <!-- </div> -->
      <!-- Date range row -->
      <!-- <div class="row g-3 mt-0 align-items-end"> -->
        <div class="col-md-2">
          <label class="form-label small fw-semibold text-muted">From Date</label>
          <input type="date" class="form-control" [value]="recDateFrom()"
            (change)="recDateFrom.set($any($event.target).value)">
        </div>
        <div class="col-md-2">
          <label class="form-label small fw-semibold text-muted">To Date</label>
          <input type="date" class="form-control" [value]="recDateTo()"
            (change)="recDateTo.set($any($event.target).value)">
        </div>
        <div class="col-auto">
          <button class="btn btn-outline-secondary" (click)="resetRecordFilters()">
            <i class="bi bi-arrow-counterclockwise me-1"></i>Reset
          </button>
        </div>
        <div class="col-auto ms-auto">
          <small class="text-muted">{{ filteredSessions().length }} session(s) found</small>
        </div>
      </div>
    </div>
  </div>

  <div class="att-card">
    <div class="ac-body p-0">
      @if (filteredSessions().length === 0) {
      <div class="empty-state"><i class="bi bi-calendar-x"></i>
        <p>No sessions match your filters</p>
      </div>
      } @else {
      <div class="table-responsive">
        <table class="att-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Class</th>
              <th>Sec.</th>
              <th>Subject</th>
              <th>Period</th>
              <th class="text-center">Total</th>
              <th class="text-center">Present</th>
              <th class="text-center">Absent</th>
              <th class="text-center">Late</th>
              <th class="text-center">H/Day</th>
              <th class="text-center">Leave</th>
              <th class="text-center">%</th>
              <th>Marked By</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            @for (s of filteredSessions(); track s.id) {
            <tr [class.holiday-row]="s.is_holiday">
              <td class="fw-semibold small">{{ formatDate(s.att_date) }}</td>
              <!-- <td class="small text-muted">{{ getDay(s.att_date) }}</td> -->
              <td class="small">{{ dataService.getClassName(s.class_name) }}</td>
              <td class="text-center small">{{ s.section }}</td>
              <td class="small text-secondary">{{ this.dataService.getSubjectName(s.subject) }}</td>
              <td class="small text-secondary">{{ s.att_period }}</td>
              @if (s.is_holiday) {
              <td colspan="7" class="text-center">
                <span class="holiday-chip"><i class="bi bi-sun-fill me-1"></i>{{ s.holiday_name }}</span>
              </td>
              } @else {
              <td class="text-center fw-semibold">{{ s.total }}</td>
              <td class="text-center"><span class="att-num present-num">{{ s.present }}</span></td>
              <td class="text-center"><span class="att-num absent-num">{{ s.absent }}</span></td>
              <td class="text-center"><span class="att-num late-num">{{ s.late }}</span></td>
              <td class="text-center"><span class="att-num halfday-num">{{ s.half_day }}</span></td>
              <td class="text-center"><span class="att-num leave-num">{{ s.on_leave }}</span></td>
              <td class="text-center">
                @let pct = attendancePct(s);
                <div class="pct-pill" [style.background]="pctColor(pct) + '22'" [style.color]="pctColor(pct)">{{ pct }}%
                </div>
              </td>
              }
              <td class="small text-secondary">{{ s.marked_by }}</td>
              <td>
                @if (s.is_holiday) {
                <span class="att-present"
                  style="background:#fef3c7;color:#92400e;padding:3px 9px;border-radius:20px;font-size:.7rem;font-weight:600;">Holiday</span>
                } @else {
                <span class="att-status-badge att-present">Done</span>
                }
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
      }
    </div>
  </div>
  }

  <!-- ===================================================
       TAB 3: REPORTS
       =================================================== -->
  @if (activeTab() === 'reports') {

  <!-- Report Filters -->
  <div class="att-card mb-3">
    <div class="ac-body">
      <div class="row g-3 align-items-end">
        <div class="col-md-3">
          <label class="form-label small fw-semibold text-muted">Class</label>
          <select class="form-select" [value]="repClass()" (change)="repClass.set($any($event.target).value)">
            <option value="">--</option>
            @for (c of classOptions; track c) { <option [value]="c.code">{{ c.name }}</option> }
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label small fw-semibold text-muted">Month</label>
          <input type="month" class="form-control" [value]="repMonth()"
            (change)="repMonth.set($any($event.target).value)">
        </div>
        <div class="col-md-4">
          <label class="form-label small fw-semibold text-muted">Search Student</label>
          <div class="input-group">
            <span class="input-group-text bg-light border-end-0"><i class="bi bi-search text-muted"></i></span>
            <input type="text" class="form-control border-start-0" placeholder="Name or roll no…" [value]="repSearch()"
              (input)="repSearch.set($any($event.target).value)">
            @if (repSearch()) { <button class="btn btn-outline-secondary" (click)="repSearch.set('')"><i
                class="bi bi-x"></i></button> }
          </div>
        </div>
        <div class="col-md-2">
          <button class="btn btn-outline-secondary" (click)="resetRepFilters()"><i
              class="bi bi-arrow-counterclockwise me-1"></i>Reset</button>
        </div>
      </div>

      <!-- Risk filter chips -->
      <div class="col-7 rep-filter-chips mt-3">
        @for (f of [{k:'all',l:'All',icon:'bi-people-fill'},{k:'above75',l:'≥ 75%
        Good',icon:'bi-check-circle-fill'},{k:'below75',l:'< 75% At
          Risk',icon:'bi-exclamation-triangle-fill'},{k:'below50',l:'< 50% Critical',icon:'bi-x-octagon-fill'}]; track
          f.k) { <button
          class="rfc-btn {{ repFilter() === f.k ? 'rfc-active' : '' }} {{ f.k === 'below50' ? 'rfc-critical' : f.k === 'below75' ? 'rfc-risk' : f.k === 'above75' ? 'rfc-good' : '' }}"
          (click)="repFilter.set($any(f.k))">
          <i class="bi {{ f.icon }} me-1"></i>{{ f.l }}
          @if (f.k === 'above75') { <span class="rfc-count">{{ repSummary().above75 }}</span> }
          @if (f.k === 'below75') { <span class="rfc-count">{{ repSummary().below75 }}</span> }
          @if (f.k === 'below50') { <span class="rfc-count">{{ repSummary().below50 }}</span> }
          </button>
          }
      </div>
    </div>
  </div>

  <!-- Summary Cards -->
  <!-- <div class="row g-3 mb-4">
    <div class="col-6 col-sm-3">
      <div class="rep-stat-card">
        <div class="rsc-val" style="color:#22c55e">{{ repSummary().avg }}%</div>
        <div class="rsc-label">Class Average</div>
      </div>
    </div>
    <div class="col-6 col-sm-3">
      <div class="rep-stat-card">
        <div class="rsc-val" style="color:#22c55e">{{ repSummary().above75 }}</div>
        <div class="rsc-label">≥ 75% (Good)</div>
      </div>
    </div>
    <div class="col-6 col-sm-3">
      <div class="rep-stat-card" style="border-color:#fde68a;background:#fffbeb;">
        <div class="rsc-val" style="color:#f59e0b">{{ repSummary().below75 }}</div>
        <div class="rsc-label">50–74% (At Risk)</div>
      </div>
    </div>
    <div class="col-6 col-sm-3">
      <div class="rep-stat-card" style="border-color:#fecaca;background:#fff5f5;">
        <div class="rsc-val" style="color:#ef4444">{{ repSummary().below50 }}</div>
        <div class="rsc-label">< 50% (Critical)</div>
      </div>
    </div>
  </div> -->

    <!-- Report Table -->
    <div class="att-card">
      <div class="ac-body p-0">
        @if (filteredReports().length === 0) {
        <div class="empty-state"><i class="bi bi-bar-chart-line"></i>
          <p>No students match the selected filter</p>
        </div>
        } @else {
        <div class="table-responsive">
          <table class="att-table rep-table">
            <thead>
              <tr>
                <th>Roll No.</th>
                <th>Student Name</th>
                <th class="text-center">Working Days</th>
                <th class="text-center" style="color:#22c55e">Present</th>
                <th class="text-center" style="color:#ef4444">Absent</th>
                <th class="text-center" style="color:#f59e0b">Late</th>
                <th class="text-center" style="color:#0ea5e9">H/Day</th>
                <th class="text-center" style="color:#8b5cf6">Leave</th>
                <th class="text-center" style="color:#6b7280">Holidays</th>
                <th class="text-center">Attendance %</th>
                <th>Status</th>
                <!-- <th>Notice</th> -->
              </tr>
            </thead>
            <tbody>
              @for (r of filteredReports(); track r.student_id) {
              @let pct = reportPct(r);
              <tr [class.row-critical]="pct < 50" [class.row-risk]="pct >= 50 && pct < 75">
                <td class="font-monospace small fw-semibold">{{ r.roll_no }}</td>
                <td>
                  <div class="d-flex align-items-center gap-2">
                    <div class="rep-avatar" [style.background]="pctColor(pct)">{{ r.student_name.charAt(0) }}</div>
                    <span class="fw-semibold small">{{ r.student_name }}</span>
                  </div>
                </td>
                <td class="text-center fw-semibold">{{ r.total_days }}</td>
                <td class="text-center"><span class="rep-num text-success">{{ r.present }}</span></td>
                <td class="text-center"><span class="rep-num text-danger">{{ r.absent }}</span></td>
                <td class="text-center"><span class="rep-num text-warning">{{ r.late }}</span></td>
                <td class="text-center"><span class="rep-num text-info">{{ r.half_day }}</span></td>
                <td class="text-center"><span class="rep-num text-purple">{{ r.on_leave }}</span></td>
                <td class="text-center"><span class="rep-num text-muted">{{ r.holidays }}</span></td>
                <td>
                  <div class="pct-bar-wrap">
                    <div class="pct-bar-bg">
                      <div class="pct-bar-fill" [style.width.%]="pct" [style.background]="pctColor(pct)"></div>
                    </div>
                    <span class="pct-label" [style.color]="pctColor(pct)">{{ pct }}%</span>
                  </div>
                </td>
                <td>
                  @if (pct >= 75) { <span class="rep-badge rep-good">Good</span> }
                  @else if (pct >= 50) { <span class="rep-badge rep-risk">At Risk</span> }
                  @else { <span class="rep-badge rep-critical">Critical</span> }
                </td>
                <!-- <td>
                      @if (pct < 75) {
                        @if (isNoticeSent(r.student_id)) {
                          <div class="notice-sent-chip">
                            <i class="bi bi-check-circle-fill"></i>
                            Sent
                          </div>
                        } @else {
                          <button class="notice-btn" (click)="openNoticeModal(r)">
                            <i class="bi bi-envelope-fill me-1"></i>Send Notice
                          </button>
                        }
                      } @else {
                        <span class="text-muted small">—</span>
                      }
                    </td> -->
              </tr>
              }
            </tbody>
          </table>
        </div>

      <!-- Low attendance alert strip -->
      @let riskStudents = lowAttendanceStudents();
      @if (riskStudents.length > 0 && repFilter() !== 'above75') {
      <div class="risk-alert-section">
        <div class="ras-header">
          <i class="bi bi-exclamation-triangle-fill text-warning me-2"></i>
          <strong>{{ riskStudents.length }} student(s) with attendance below 75%</strong>
          <span class="text-muted small ms-2">— Parent notice required</span>
          <div class="ms-auto d-flex align-items-center gap-2">
            @if (noticeCount() > 0) {
            <span class="text-success small"><i class="bi bi-check-circle-fill me-1"></i>{{ noticeCount() }} notice(s)
              sent</span>
            }
            <button class="btn btn-sm btn-warning fw-semibold" (click)="sendAllNotices()">
              <i class="bi bi-envelope-fill me-1"></i>Send All Remaining
            </button>
          </div>
        </div>
        <div class="ras-list">
          @for (r of riskStudents; track r.student_id) {
          <div class="ras-item" [class.ras-critical]="r.percentage < 50">
            <div class="ras-av" [style.background]="pctColor(r.percentage)">{{ r.student_name.charAt(0) }}</div>
            <div>
              <div class="fw-semibold small">{{ r.student_name }}</div>
              <div class="tiny text-muted">{{ r.roll_no }}</div>
            </div>
            <div class="ras-stats">
              <span class="text-danger small fw-semibold">{{ r.absent }} absent</span>
              <span class="text-muted small ms-1">· {{ r.late }} late</span>
            </div>
            <span class="fw-bold ms-auto me-2" [style.color]="pctColor(r.percentage)">{{ r.percentage }}%</span>
            @if (r.percentage < 50) { <span class="rep-badge rep-critical me-2">Critical</span> }
              @else { <span class="rep-badge rep-risk me-2">At Risk</span> }
              @if (isNoticeSent(r.student_id)) {
              <div class="notice-sent-chip">
                <i class="bi bi-check-circle-fill"></i>
                Sent · {{ getNoticeSentTime(r.student_id) }}
              </div>
              } @else {
              <button class="ras-action" (click)="openNoticeModal(r)">
                <i class="bi bi-envelope-fill me-1"></i>Send Notice
              </button>
              }
          </div>
          }
        </div>
      </div>
      }
      }
    </div>
  </div>
  }

  <!-- ===================================================
       TAB 4: LEAVES
       =================================================== -->
  @if (activeTab() === 'leaves') {

  <!-- Add Leave Modal -->
  @if (showAddLeave()) {
  <div class="att-overlay" (click)="showAddLeave.set(false)">
    <div class="att-modal" (click)="$event.stopPropagation()">
      <div class="amh" style="background:linear-gradient(135deg,#1a3a6b,#2d6a9f)">
        <div class="amh-icon"><i class="bi bi-calendar-plus-fill"></i></div>
        <div>
          <h5 class="amh-title">Add Leave Application</h5>
          <p class="amh-sub">Fill details and submit</p>
        </div>
        <button class="amh-close" (click)="showAddLeave.set(false)"><i class="bi bi-x-lg"></i></button>
      </div>
      <div class="amb p-4">
        <!-- Student Lookup -->
        <div class="student-lookup mb-4">
          <label class="form-label fw-semibold">Roll No./Admn.No./Name <span class="req">*</span></label>
          <div class="input-group">
            <span class="input-group-text bg-light"><i class="bi bi-person-fill text-muted"></i></span>
            <input type="text" class="form-control" [(ngModel)]="std_kw"
              (keyup.enter)="loadStudentDetails()">
            <button class="btn btn-primary" (click)="loadStudentDetails()"><i class="bi bi-search me-1"></i>Fetch</button>
          </div>
        </div>

        <div class="row g-3">
          <div class="col-md-5"><label class="form-label fw-semibold">Student ID <span class="req">*</span></label>
            <input type="text" class="form-control" [(ngModel)]="newLeave.student_id" placeholder="e.g. S001"
              [class.is-invalid]="leaveSubmitted && !newLeave.student_id" readonly>
          </div>
          <div class="col-md-7"><label class="form-label fw-semibold">Student Name <span class="req">*</span></label>
            <input type="text" class="form-control" [(ngModel)]="newLeave.student_name" placeholder="Full name"
              [class.is-invalid]="leaveSubmitted && !newLeave.student_name">
          </div>
          <div class="col-md-6"><label class="form-label fw-semibold">Class</label>
            <select class="form-select" [(ngModel)]="newLeave.class_name">
              <option value="">-- Select --</option>
              @for (c of classOptions; track c) { <option [value]="c.code">{{ c.name }}</option> }
            </select>
          </div>
          <div class="col-md-6"><label class="form-label fw-semibold">Leave Type <span class="req">*</span></label>
            <select class="form-select" [(ngModel)]="newLeave.leave_type"
              [class.is-invalid]="leaveSubmitted && !newLeave.leave_type">
              <option value="">-- Select --</option>
              @for (t of leaveTypes; track t) { <option [value]="t">{{ t }}</option> }
            </select>
          </div>
          <div class="col-6"><label class="form-label fw-semibold">From Date <span class="req">*</span></label>
            <input type="date" class="form-control" [(ngModel)]="newLeave.from_date"
              [class.is-invalid]="leaveSubmitted && !newLeave.from_date">
          </div>
          <div class="col-6"><label class="form-label fw-semibold">To Date <span class="req">*</span></label>
            <input type="date" class="form-control" [(ngModel)]="newLeave.to_date"
              [class.is-invalid]="leaveSubmitted && !newLeave.to_date">
          </div>
          <div class="col-12"><label class="form-label fw-semibold">Reason <span class="req">*</span></label>
            <textarea class="form-control" [(ngModel)]="newLeave.reason" rows="3" maxlength="300"
              placeholder="Reason for leave application…"
              [class.is-invalid]="leaveSubmitted && !newLeave.reason"></textarea>
          </div>
        </div>
      </div>
      <div class="amf">
        <button class="btn btn-outline-secondary px-4" (click)="showAddLeave.set(false)">Cancel</button>
        <button class="btn att-btn-primary px-5" (click)="submitNewLeave()">
          <i class="bi bi-send-fill me-2"></i>Submit Application
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Leave Stats -->
  <!-- <div class="row g-3 mb-4">
    <div class="col-6 col-sm-2">
      <div class="leave-stat-card">
        <div class="lsc-val">{{ leaveSummary().total }}</div>
        <div class="lsc-label">Total</div>
      </div>
    </div>
    <div class="col-6 col-sm-2">
      <div class="leave-stat-card lsc-pending">
        <div class="lsc-val text-warning">{{ leaveSummary().pending }}</div>
        <div class="lsc-label">Pending</div>
      </div>
    </div>
    <div class="col-6 col-sm-2">
      <div class="leave-stat-card">
        <div class="lsc-val text-success">{{ leaveSummary().approved }}</div>
        <div class="lsc-label">Approved</div>
      </div>
    </div>
    <div class="col-6 col-sm-2">
      <div class="leave-stat-card">
        <div class="lsc-val text-danger">{{ leaveSummary().rejected }}</div>
        <div class="lsc-label">Rejected</div>
      </div>
    </div>
    <div class="col-12 col-sm-3 ms-auto">
      <div class="leave-stat-card d-flex align-items-center justify-content-center">
        <button class="btn att-btn-primary w-100" (click)="showAddLeave.set(true); leaveSubmitted=false">
          <i class="bi bi-plus-circle-fill me-1"></i>Add Leave Application
        </button>
      </div>
    </div>
  </div> -->

  <!-- Enhanced Filters -->
  <div class="att-card mb-3">
    <div class="btnTR">
      <button class="btn att-btn-primary py-1 px-2" (click)="showAddLeave.set(true); leaveSubmitted=false">
        <i class="bi bi-plus-circle-fill me-1"></i>Leave Application
      </button>
    </div>
    <div class="ac-body">
      <div class="row g-3 align-items-end">
        <!-- Search -->
        <div class="col-md-4">
          <label class="form-label small fw-semibold text-muted">Search</label>
          <div class="input-group">
            <span class="input-group-text bg-light border-end-0"><i class="bi bi-search text-muted"></i></span>
            <input class="form-control border-start-0" placeholder="Student name, ID or roll no…"
              [value]="leaveSearch()" (input)="leaveSearch.set($any($event.target).value)">
            @if (leaveSearch()) { <button class="btn btn-outline-secondary" (click)="leaveSearch.set('')"><i
                class="bi bi-x"></i></button> }
          </div>
        </div>
        <!-- Class -->
        <div class="col-md-2">
          <label class="form-label small fw-semibold text-muted">Class</label>
          <select class="form-select" [value]="leaveClass()" (change)="leaveClass.set($any($event.target).value)">
            <option value="">All Classes</option>
              @for (c of classOptions; track c) { <option [value]="c.code">{{ c.name }}</option> }
          </select>
        </div>
        <!-- Leave Type -->
        <div class="col-md-2">
          <label class="form-label small fw-semibold text-muted">Leave Type</label>
          <select class="form-select" [value]="leaveType()" (change)="leaveType.set($any($event.target).value)">
            <option value="">All Types</option>
            @for (t of leaveTypes; track t) { <option [value]="t">{{ t }}</option> }
          </select>
        </div>
        <!-- Status -->
        <div class="col-md-2">
          <label class="form-label small fw-semibold text-muted">Status</label>
          <select class="form-select" [value]="leaveStatus()" (change)="leaveStatus.set($any($event.target).value)">
            <option value="">All Statuses</option>
            @for (s of ['Pending','Approved','Rejected','Cancelled']; track s) { <option [value]="s">{{ s }}</option> }
          </select>
        </div>
        <!-- Reset -->
        <div class="col-auto">
          <button class="btn btn-outline-secondary" (click)="resetLeaveFilters()">
            <i class="bi bi-arrow-counterclockwise me-1"></i>Reset
          </button>
        </div>
      </div>
      <!-- Date range -->
      <div class="row g-3 mt-0 align-items-end">
        <div class="col-md-2">
          <label class="form-label small fw-semibold text-muted">From Date</label>
          <input type="date" class="form-control" [value]="leaveDateFrom()"
            (change)="leaveDateFrom.set($any($event.target).value)">
        </div>
        <div class="col-md-2">
          <label class="form-label small fw-semibold text-muted">To Date</label>
          <input type="date" class="form-control" [value]="leaveDateTo()"
            (change)="leaveDateTo.set($any($event.target).value)">
        </div>
        <div class="col-auto ms-auto">
          <small class="text-muted">{{ filteredLeaves().length }} application(s) found</small>
        </div>
      </div>
    </div>
  </div>

  <!-- Leave Applications List -->
  @if (filteredLeaves().length === 0) {
  <div class="empty-state"><i class="bi bi-calendar-x"></i>
    <p>No leave applications match your filters</p>
  </div>
  } @else {
  <div class="leave-list">
    @for (leave of filteredLeaves(); track leave.id) {
    <div class="leave-card" [class.leave-pending]="leave.status === 'Pending'"
      [class.leave-approved]="leave.status === 'Approved'" [class.leave-rejected]="leave.status === 'Rejected'">
      <div class="lc-left">
        <div class="lc-avatar" [class.lca-pending]="leave.status === 'Pending'"
          [class.lca-approved]="leave.status === 'Approved'" [class.lca-rejected]="leave.status === 'Rejected'">
          {{ leave.student_name.charAt(0) }}
        </div>
        <div>
          <div class="lc-name">{{ leave.student_name }}</div>
          <div class="lc-meta">{{ leave.class_name }} · Roll: {{ leave.roll_no }} · ID: {{ leave.student_id }}</div>
        </div>
      </div>
      <div class="lc-middle">
        <div class="lc-type">{{ leave.leave_type }}</div>
        <div class="lc-dates">
          <i class="bi bi-calendar3 me-1"></i>
          {{ formatDate(leave.from_date) }} → {{ formatDate(leave.to_date) }}
          <span class="ms-2 lc-days">{{ leave.total_days }} day(s)</span>
        </div>
        <div class="lc-reason">{{ leave.reason }}</div>
        @if (leave.review_remark && leave.status !== 'Pending') {
        <div class="lc-remark-preview" [title]="leave.review_remark">
          <i class="bi bi-chat-quote me-1"></i>{{ leave.review_remark | slice:0:40 }}{{ leave.review_remark.length > 40
          ? '…' : '' }}
        </div>
        }
      </div>
      <div class="lc-right">
        <span class="leave-status-badge {{ getLeaveStatusClass(leave.status) }}">{{ leave.status }}</span>
        <div class="small text-muted mt-1">Applied: {{ formatDate(leave.applied_on) }}</div>
        @if (leave.reviewed_by) { <div class="small text-muted">By: {{ leave.reviewed_by }}</div> }
        <!-- View + Edit buttons (always visible) -->
        <div class="lc-actions mt-2 d-flex gap-2">
          <button class="lcb view py-0" (click)="openLeaveDetail(leave)" title="View full details">
            <i class="bi bi-eye-fill me-1"></i>View
          </button>
          <button class="lcb lc-edit" (click)="openEditLeave(leave)" title="Edit application">
            <i class="bi bi-pencil-fill me-1"></i>Edit
          </button>
          <!-- Approve / Reject (pending only) -->
          @if (leave.status === 'Pending') {
            <button class="lra-approve" (click)="quickApprove(leave.id)">
              <i class="bi bi-check-circle-fill me-1"></i>Approve
            </button>
            <button class="lra-reject" (click)="openQuickReject(leave.id)">
              <i class="bi bi-x-circle-fill me-1"></i>Reject
            </button>
          }
        </div>
      </div>
    </div>
    }
  </div>
  }
  }

</div>